import { initVueApp } from '../../lib/utils/vue3compat/init_vue_app.js?vue3';
import { pinia } from '../../pinia/instance.js?vue3';
import FileByFileNavigation from './file_by_file_navigation.vue?vue3';

export function initFileByFileNavigation(el) {
  if (!el) return;

  initVueApp({ el, name: 'FileByFileNavigationRoot', pinia, component: FileByFileNavigation });
}
